export default {
  path: '',
  name: 'appSetting',
  meta: {
    title: '',
    level: 1,
    role: ['admin']
  },
  component: () => import('@/views/Application.vue'),
  hidden: true,
  children: [
    {
      path: '/appSetting',
      name: 'appSetting',
      meta: {
        title: 'APP首页数据设置',
        role: ['admin'],
        level: 2
      },
      component: () => import('@/views/appSetting')
    },
    {
      path: '/addAppSetting',
      name: 'addAppSetting',
      meta: {
        title: '添加数据',
        level: 3,
        role: ['admin']
      },
      component: () => import('@/views/appSetting/sub')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/appSetting.js